import { Modal } from 'antd';

export const ModalComponent = ({open, title, loading, children, saveData, onCancel, ...props}) => {
    return (
        <>
            <Modal
                title={title}
                onOk={saveData}
                open={open}
                confirmLoading={loading}
                onCancel={onCancel}
                {...props}
            >
                {children}
            </Modal>
        </>
    );
};